import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { toggleSidebar } from '../../store/slices/layoutSlice';
import Sidebar from './Sidebar';
import Header from './Header';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-right: ${props => props.sidebarOpen ? '280px' : '0'};
  transition: margin-right 0.3s ease;
  
  @media (max-width: 768px) {
    margin-right: 0;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  padding: 20px;
  background: transparent;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Layout = ({ children }) => {
  const { sidebarOpen } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  return (
    <LayoutContainer>
      <Sidebar isOpen={sidebarOpen} onToggle={handleToggleSidebar} />
      <MainContent sidebarOpen={sidebarOpen}>
        <Header onToggleSidebar={handleToggleSidebar} />
        <ContentArea>
          {children}
        </ContentArea>
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;
